"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationSupportCTA = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Link = require("design_system/Link");
var _Icon = require("design_system/Icon");
var _Layout = require("design_system/Layout");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TRANSLATION_SUPPORT_PAGE_ROUTE = "/patient/translation-support/";
const TranslationSupportCTA = _ref => {
  var _window, _window$location;
  let {
    onClose,
    ctaMessage
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(true);
  const onCalloutClose = () => {
    setOpen(false);
    onClose && onClose();
  };
  if (!open) return null;
  const queryParams = new URLSearchParams((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search);
  const userId = queryParams.get("user");
  const supportLink = userId ? `${TRANSLATION_SUPPORT_PAGE_ROUTE}?user=${userId}` : TRANSLATION_SUPPORT_PAGE_ROUTE;
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, {
    p: "px-24 py-16",
    rounded: "rounded-8",
    bg: "bg-gray-f4f5f7",
    border: "border border-gray-a9acc4",
    className: "flex leading-1_5"
  }, /*#__PURE__*/_react.default.createElement(_Link.Link, {
    className: "flex-1",
    href: supportLink,
    "data-patient-app-click": "translation_callout_link_click"
  }, ctaMessage), /*#__PURE__*/_react.default.createElement("button", {
    className: "text-gray-65657b hover:text-gray-171731",
    type: "button",
    "aria-label": "close",
    onClick: onCalloutClose,
    "data-patient-app-click": "translation_callout_close"
  }, /*#__PURE__*/_react.default.createElement(_Icon.X, {
    "aria-hidden": "true"
  })));
};
exports.TranslationSupportCTA = TranslationSupportCTA;